module.exports = "/images/circle-cross.svg?e9a112a07c29e90ea7e4557ed283ab04";